import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { Avatar } from 'src/game/components/shared/Avatar';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import buttons from 'src/lib/ui/config/buttons';
import { Feature } from 'src/replicant/analytics';

type BuddiesBakerProfileOpts = ViewOpts & {
  index: number;
  onInvite?: () => Promise<void>;
  onTapPlayer?: () => void;
};

export class BuddiesBakerProfile extends View {
  private placeholder: ButtonScaleView;
  private name: LangBitmapFontTextView;
  private avatar: Avatar;
  public button: ButtonScaleViewWithText;

  constructor(opts: BuddiesBakerProfileOpts) {
    super({
      width: 140,
      height: 160,
      centerOnOrigin: true,
      ...opts,
    });

    this.placeholder = new ButtonScaleView({
      superview: this,
      image: 'assets/ui/buddies/common/friend_icon.png',
      width: 69,
      height: 66,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: 50,
      tracking: {
        feature: Feature.BUDDIES._,
        $subFeature: Feature.BUDDIES.BUTTON_INVITE,
      },
      onClick: async () => opts?.onInvite?.(),
    });

    this.avatar = new Avatar({
      superview: this,
      x: this.style.width / 2,
      y: 50,
      width: 80,
      height: 80,
      // Add a border to the avatar, with a different color for the first slot (main user)
      borderTint: !opts.index ? '#FFEC8B' : '#FFFFFF',
      onClick: opts?.onTapPlayer ? async () => opts.onTapPlayer!() : undefined,
    });

    this.name = new LangBitmapFontTextView({
      superview: this,
      x: this.avatar.style.x,
      y: this.avatar.style.y + this.avatar.style.height / 2 + 25,
      align: 'center',
      anchorY: 0.5,
      size: 18,
      font: 'Body',
      color: '#603070',
      width: this.style.width,
      height: 30,
      centerOnOrigin: true,
      localeText: () => 'Baker Name',
    });

    this.button = new ButtonScaleViewWithText({
      superview: this,
      ...buttons.secondary,
      width: this.style.width - 10,
      height: 70,
      fontSize: 26,
      labelOffsetY: -2,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: this.style.height - 30,
      font: 'Body',
      tracking: {
        feature: Feature.BUDDIES._,
        $subFeature: Feature.BUDDIES.BUTTON_INVITE,
      },
      localeText: () => i18n('match2.buddies.invitePopup.invite'),
      onClick: async () => opts?.onInvite?.(),
    });

    // Initial state is empty
    this.clearPlayer();
  }

  public setPlayer(player: { name: string; photo: string }) {
    this.name.show();
    this.avatar.show();
    this.name.localeText = () => player.name;
    this.avatar.updateImage(player.photo);
    this.placeholder.hide();
    this.button.hide();
  }

  public clearPlayer() {
    this.placeholder.show();
    this.button.show();
    this.name.hide();
    this.avatar.hide();
  }
}
